module.exports = __webpack_public_path__ + "img/ai-fuzhu.c60e1aed.png";